import classNames from 'classnames';
import ProductSplash, { TProductSplashProps } from './ProductSplash';

export type ProductSplashesProps = {
    splashes?: TProductSplashProps[];
    numberOfSplashes?: number;
    className?: string;
};

function ProductSplashes({
    splashes = [],
    numberOfSplashes,
    className = '',
}: ProductSplashesProps) {
    const splashesToDisplay = splashes?.slice(0, numberOfSplashes ?? splashes.length);

    return splashes && splashesToDisplay?.length > 0 ? (
        <div className={classNames('product-splashes', className)}>
            {
                splashesToDisplay.map((splash, index) => {
                    const {
                        label, color, backgroundColor,
                    } = splash;
                    const uniqueKey = `${label}-${index}`;
                    return (
                        <ProductSplash
                            key={uniqueKey}
                            backgroundColor={backgroundColor}
                            color={color}
                            label={label}
                        />
                    );
                })
            }
        </div>
    ) : null;
}

export default ProductSplashes;
